import { Link, useLocation, useNavigate } from 'react-router-dom';
import { scrollToSection } from 'utils/scrollToSection';

function NavHashLink({ to, className, children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const hashIndex = to.indexOf('#');
  const path = hashIndex === -1 ? to : to.slice(0, hashIndex) || '/';
  const hash = hashIndex === -1 ? '' : to.slice(hashIndex);

  const handleClick = (event) => {
    if (path !== '/' || !hash || location.pathname !== '/') {
      return;
    }

    event.preventDefault();
    const sectionId = hash.slice(1);
    navigate({ pathname: '/', hash: sectionId });
    scrollToSection(sectionId);
  };

  return (
    <Link to={to} className={className} onClick={handleClick}>
      {children}
    </Link>
  );
}

export default NavHashLink;
